module.exports = __webpack_public_path__ + "static/media/shopping-bag.e2d6dfb6.png";